import { FormatIcu } from '@tolgee/format-icu';
import { BackendFetch, DevTools, Tolgee } from '@tolgee/react';

// Locale data lives in locales.js so CJS config files (next-i18next.config.js) can also consume it.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const _locales = require('./locales') as {
  localeOptions: [string, string][];
  SupportedLocales: string[];
  DefaultLocale: string;
};

export const localeOptions = _locales.localeOptions;
export const SupportedLocales = _locales.SupportedLocales;
export const DefaultLocale = _locales.DefaultLocale;

export const tolgee = Tolgee()
  .use(DevTools())
  .use(FormatIcu())
  .use(
    BackendFetch({
      // We async client side fetch the translations from the server. This reduces the bundle size. TODO = move this to CDN during CICD
      prefix: `${process.env.NEXT_PUBLIC_CDN_URL}/i18n`,
    }),
  )
  .init({
    defaultLanguage: DefaultLocale,
    // for dev mode
    apiUrl: process.env.NEXT_PUBLIC_TOLGEE_API_URL,
    apiKey: process.env.NEXT_PUBLIC_TOLGEE_API_KEY,
    availableLanguages: [...localeOptions.map(([value]) => value)],
    // for production and server
    staticData: {},
  });
